import type { EducationInfo, EducationPayload } from '../../../../pages/common';
import type {
  ITreatmentPlanV3EducationPage,
  TreatmentPlanV3EducationInfoRequest,
  TreatmentPlanV3EducationPageResponse,
} from './types';

export function toTreatmentPlanV3EducationPage(
  response: TreatmentPlanV3EducationPageResponse,
): ITreatmentPlanV3EducationPage {
  return {
    not_attending_school: response.not_attending_school,
    education_info: toEducationInfo(response),
  };
}

function toEducationInfo(response: TreatmentPlanV3EducationPageResponse): EducationInfo | null {
  const educationInfo = {
    education_setting: response.education_setting,
    number_of_hours_per_week: response.number_of_hours_per_week,
    school_name: response.school_name,
    school_phone_number: response.school_phone_number,
    education_description: response.education_description,
    focus_area_description: response.focus_area_description,
    client_education_evaluation_status: response.evaluation_status,
    client_education_evaluation_date: response.evaluation_date,
    iep_or_504_in_place: response.iep_or_504_in_place,
    education_support: response.education_support,
    client_classroom_setting: response.classroom_setting,
    client_attitude_towards_school: response.attitude_towards_school,
  };

  // A plan with nothing filled in returns every field as null, which the form treats as no info yet.
  return Object.values(educationInfo).every((value) => value == null) ? null : educationInfo;
}

export function toTreatmentPlanV3EducationInfoRequest(
  data: EducationPayload,
): TreatmentPlanV3EducationInfoRequest {
  const {
    client_education_evaluation_status,
    client_education_evaluation_date,
    client_classroom_setting,
    client_attitude_towards_school,
    ...sharedFields
  } = data;
  const request: TreatmentPlanV3EducationInfoRequest = { ...sharedFields };

  // Only keys the caller actually sent are forwarded, so an unchanged field is never patched to null.
  if ('client_education_evaluation_status' in data) {
    request.evaluation_status = client_education_evaluation_status;
  }
  if ('client_education_evaluation_date' in data) {
    request.evaluation_date = client_education_evaluation_date;
  }
  if ('client_classroom_setting' in data) {
    request.classroom_setting = client_classroom_setting;
  }
  if ('client_attitude_towards_school' in data) {
    request.attitude_towards_school = client_attitude_towards_school;
  }

  return request;
}
